// import { automationAllowedLimit } from "@/functions/automation.js";
export default {
  components: {},
  data() {
    return {
      // show: !!automationAllowedLimit(),
      show: false,
      version: "15",
      maintanace: window.localStorage.getItem("maintanace")
    };
  },
  methods: {
    close() {
      this.show = false;
      window.localStorage.setItem("maintanace", this.version);
    }
  }
};